import React from 'react';

import type { IntroductoryParagraphBlock as IntroductoryParagraphBlockProps } from '@/payload-types';

import styles from './block.module.scss';

export const IntroductoryParagraphBlock: React.FC<
  IntroductoryParagraphBlockProps
> = (props) => {
  const { text } = props;

  if (!text) return null;

  return <p className={styles.introductoryParagraph}>{text}</p>;
};
